import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
require('./main.js')

window.console = (function () {
    var c = { ...window.console };
    c.error = function () { };
    return c;
})();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
